// =====================================================================
// Meeting AI (Notetaker) — action types
// =====================================================================

// ---------- meetingrecording (RECORDING) ----------
export const MEETING_RECORDING_LIST = "MEETING_RECORDING_LIST";
export const MEETING_RECORDING_LIST_SUCCESS = "MEETING_RECORDING_LIST_SUCCESS";
export const MEETING_RECORDING_LIST_FAIL = "MEETING_RECORDING_LIST_FAIL";

export const MEETING_RECORDING_DATA = "MEETING_RECORDING_DATA";
export const MEETING_RECORDING_DATA_SUCCESS = "MEETING_RECORDING_DATA_SUCCESS";
export const MEETING_RECORDING_DATA_FAIL = "MEETING_RECORDING_DATA_FAIL";

// Sends the notetaker bot to a meeting — immediately, or at
// ScheduledJoinDateTime when the caller supplies one.
export const MEETING_RECORDING_DISPATCH = "MEETING_RECORDING_DISPATCH";
export const MEETING_RECORDING_DISPATCH_SUCCESS =
  "MEETING_RECORDING_DISPATCH_SUCCESS";
export const MEETING_RECORDING_DISPATCH_FAIL =
  "MEETING_RECORDING_DISPATCH_FAIL";
export const MEETING_RECORDING_DISPATCH_RESET =
  "MEETING_RECORDING_DISPATCH_RESET";

export const MEETING_RECORDING_UPDATE = "MEETING_RECORDING_UPDATE";
export const MEETING_RECORDING_UPDATE_SUCCESS =
  "MEETING_RECORDING_UPDATE_SUCCESS";
export const MEETING_RECORDING_UPDATE_FAIL = "MEETING_RECORDING_UPDATE_FAIL";
export const MEETING_RECORDING_UPDATE_RESET = "MEETING_RECORDING_UPDATE_RESET";

export const MEETING_RECORDING_DELETE = "MEETING_RECORDING_DELETE";
export const MEETING_RECORDING_DELETE_SUCCESS =
  "MEETING_RECORDING_DELETE_SUCCESS";
export const MEETING_RECORDING_DELETE_FAIL = "MEETING_RECORDING_DELETE_FAIL";
export const MEETING_RECORDING_DELETE_RESET = "MEETING_RECORDING_DELETE_RESET";

// Re-runs AI summarisation for a recording whose summary failed.
export const MEETING_RECORDING_RETRY_SUMMARY =
  "MEETING_RECORDING_RETRY_SUMMARY";
export const MEETING_RECORDING_RETRY_SUMMARY_SUCCESS =
  "MEETING_RECORDING_RETRY_SUMMARY_SUCCESS";
export const MEETING_RECORDING_RETRY_SUMMARY_FAIL =
  "MEETING_RECORDING_RETRY_SUMMARY_FAIL";
export const MEETING_RECORDING_RETRY_SUMMARY_RESET =
  "MEETING_RECORDING_RETRY_SUMMARY_RESET";

// Pulls the latest bot/recording state back from the provider.
export const MEETING_RECORDING_SYNC = "MEETING_RECORDING_SYNC";
export const MEETING_RECORDING_SYNC_SUCCESS = "MEETING_RECORDING_SYNC_SUCCESS";
export const MEETING_RECORDING_SYNC_FAIL = "MEETING_RECORDING_SYNC_FAIL";
export const MEETING_RECORDING_SYNC_RESET = "MEETING_RECORDING_SYNC_RESET";

// ---------- meetingrecording/settings (SETTINGS) ----------
export const MEETING_RECORDING_SETTINGS = "MEETING_RECORDING_SETTINGS";
export const MEETING_RECORDING_SETTINGS_SUCCESS =
  "MEETING_RECORDING_SETTINGS_SUCCESS";
export const MEETING_RECORDING_SETTINGS_FAIL = "MEETING_RECORDING_SETTINGS_FAIL";

export const MEETING_RECORDING_SETTINGS_UPDATE =
  "MEETING_RECORDING_SETTINGS_UPDATE";
export const MEETING_RECORDING_SETTINGS_UPDATE_SUCCESS =
  "MEETING_RECORDING_SETTINGS_UPDATE_SUCCESS";
export const MEETING_RECORDING_SETTINGS_UPDATE_FAIL =
  "MEETING_RECORDING_SETTINGS_UPDATE_FAIL";
export const MEETING_RECORDING_SETTINGS_UPDATE_RESET =
  "MEETING_RECORDING_SETTINGS_UPDATE_RESET";
